import { HomeScreen } from "./screens/HomeScreen";
import { TechRadarScreen } from "./screens/TechRadarScreen";
import { Header } from "./components/Header/index.js";
import { ScoreBreakdownScreen } from "./screens/ScoreBreakdownScreen";
import { TechProfileScreen } from "./screens/TechProfileScreen";
import { ProjectInfoScreen } from "./screens/ProjectInfoScreen";
import { useRoute, useRouter } from "wouter";
import "./styles/normalise.scss";
import "./styles/global.scss";
import { AnimatePresence, motion } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { pageView } from "./utils/analytics";
import { useEffect } from "react";
import { NotFoundScreen } from "./screens/NotFoundScreen";

export function App() {
	// let [location] = useLocation();
	const { base } = useRouter();
	const [homeMatch] = useRoute("/");
	const [breakdownMatch] = useRoute("/score-breakdown");
	const [breakdownMatchInfo] = useRoute("/score-breakdown/:slug");
	const [breakdownProjectInfoMatch] = useRoute("/score-breakdown/project-info");

	const [radarMatch] = useRoute("/tech-radar");
	const [radarBackgroundMatch] = useRoute("/tech-radar/:slug");
	const [radarCategoryMatch] = useRoute("/tech-radar/category/:slug");
	const [radarProjectInfoMatch] = useRoute("/tech-radar/project-info");

	useEffect(() => {
		if (homeMatch) {
			pageView(`${base}/`, "The Virtual Economy Technology Radar | L'Atelier");
		}
	}, [homeMatch, base]);
	useEffect(() => {
		if (breakdownMatch) {
			pageView(
				`${base}/score-breakdown`,
				"Score Breakdown | L'Atelier Virtual Economy Technology Radar"
			);
		}
	}, [breakdownMatch, base]);
	useEffect(() => {
		if (radarMatch) {
			pageView(
				`${base}/tech-radar`,
				"Tech Radar | L'Atelier Virtual Economy Technology Radar"
			);
		}
	}, [radarMatch, base]);

	return (
		<HelmetProvider>
			<div className="App">
				<AnimatePresence exitBeforeEnter={true}>
					{!homeMatch ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							key={"header"}
							exit={{ opacity: 0 }}>
							<Header />
						</motion.div>
					) : (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							key={"home-header"}
							exit={{ opacity: 0 }}
						/>
					)}
				</AnimatePresence>
				<AnimatePresence exitBeforeEnter={true}>
					{homeMatch ? (
						<motion.div
							key={"home"}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}>
							<HomeScreen />
						</motion.div>
					) : null}
					{radarMatch ||
					radarBackgroundMatch ||
					radarCategoryMatch ||
					radarProjectInfoMatch ? (
						<motion.div
							key={"radar"}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}>
							<TechRadarScreen />
						</motion.div>
					) : null}
					{breakdownMatch || breakdownMatchInfo || breakdownProjectInfoMatch ? (
						<motion.div
							key={"breakdown"}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}>
							<ScoreBreakdownScreen />
						</motion.div>
					) : null}
					{!(
						breakdownMatch ||
						breakdownMatchInfo ||
						breakdownProjectInfoMatch ||
						radarMatch ||
						radarBackgroundMatch ||
						radarCategoryMatch ||
						radarProjectInfoMatch ||
						homeMatch
					) ? (
						<motion.div
							key={"404"}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}>
							<NotFoundScreen />
						</motion.div>
					) : null}
				</AnimatePresence>

				<TechProfileScreen />
				<ProjectInfoScreen />
			</div>
		</HelmetProvider>
	);
}
